/**
* this reusable function is using to confirm that user want to close the modal with unsaved changes
* @param {Function} openDialog - function to open the dialog
* @param {Function} closeDialog - function to close the dialog
* @param {Function} closeModal - function to close the main modal
* @returns {void} return functionality to close the main modal or leave it visible
*/

export const closeDialogWithUnsavedChanges = (
  openDialog, closeDialog, closeModal, setIsUnsavedChanges,
) => {
  openDialog({
    message: ['Discard unsaved changes?'],
    show: true,
    actions: [
      {
        label: 'Discard changes',
        onClick: () => {
          if (setIsUnsavedChanges) {
            setIsUnsavedChanges(false);
          }
          closeDialog();
          closeModal();
        },
        variant: 'secondary',

      },
      {
        label: 'Keep editing',
        onClick: () => {
          closeDialog();
        },
        variant: 'primary',
      },
    ],
  });
};
